import * as yup from 'yup';

export interface IChangePassword {
	passwordOld: string;
	passwordNew: string;
	passwordConfirm: string;
}

export const changePasswordInitialValues: IChangePassword = {
	passwordOld: '',
	passwordNew: '',
	passwordConfirm: '',
};

export const changePasswordSchema = yup.object().shape({
	passwordOld: yup.string().required('required'),
	passwordNew: yup.string().required('required').min(6, 'tooShort'),
	passwordConfirm: yup
		.string()
		.required('required')
		.min(6, 'tooShort')
		.test('passwords-match', 'Passwords must match', function (value) {
			return this.parent.passwordNew === value;
		}),
});
